import { ref } from "vue"
import { RoleTypes } from "@/enums/role-types"
import type { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model"

export type MentionDetailKind = "person" | "project" | "business" | "location"

export type MentionDetail = {
  kind: MentionDetailKind
  id: string
}

/** Shared open state for {@link MentionDetailModal}. */
export const mentionDetail = ref<MentionDetail | null>(null)

/** Read-only mention sheet for service providers; planners use edit forms instead. */
export function shouldUseReadOnlyMentionDetailModal(
  contact: KnownBusinessEntityContact | null | undefined
): boolean {
  return !!contact?.hasRole(RoleTypes.SERVICE_PROVIDER) && !contact?.hasRole(RoleTypes.PLANNER)
}

export function openMentionDetail(next: MentionDetail) {
  mentionDetail.value = next
}

export function closeMentionDetail() {
  mentionDetail.value = null
}
